(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('ExchangerateDeleteController',ExchangerateDeleteController);

    ExchangerateDeleteController.$inject = ['$uibModalInstance', 'entity', 'Exchangerate'];

    function ExchangerateDeleteController($uibModalInstance, entity, Exchangerate) {
        var vm = this;

        vm.exchangerate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Exchangerate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
